module.exports = __webpack_public_path__ + "static/media/img-price.42eb0d4d.png";